export default __webpack_public_path__ + "static/media/RAMEN.f144a0e3.svg";